module.exports = __webpack_public_path__ + "static/media/maf-45.b170b8c9.png";